import { useContext } from "react";
import { Table } from "antd";

import useTabAppUsers from "./useTabAppUsers";
import ActiveFiltersBar from "../../../../../components/ActiveFiltersBar";
import TableCard from "../../../../../components/TableCard";
import TableDicaHint from "../../../../../components/TableDicaHint";
import TablePagination from "../../../../../components/TablePagination";
import { ThemeContext } from "../../../../../contexts/ThemeContext";

export default function TabAppUsers() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        isLoading,
        columns,
        tableData,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        handleClickViewHelpAndSupport,
    } = useTabAppUsers();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {/* Active Filters Bar */}
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha ou utilize o botão de ação para abrir o atendimento e responder ao cidadão." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="chamados"
                pageSizeOptions={["10", "25", "50", "100"]}
            />

            {/* Table Container */}
            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    onChange={handleTableChange}
                    scroll={{ x: 1000 }}
                    onRow={(record) => ({
                        onClick: () => {
                            handleClickViewHelpAndSupport(record);
                        },
                        style: {
                            cursor: "pointer",
                        },
                    })}
                    locale={{
                        emptyText: "Nenhum chamado de usuário do aplicativo encontrado.",
                    }}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="chamados"
                pageSizeOptions={["10", "25", "50", "100"]}
            />
        </div>
    );
}
